import cx from "classnames";

import Container from "client/common/components/layouts/Container";

import { SingleVisualBlock as SingleVisualBlockType } from "../../types";
import MarkdownText from "../helper/MarkdownText";
import Block from "../Block";

import styles from "../../styles/SingleVisualBlock.module.less";

type SingleVisualBlockProps = {
  className: string;
  block: SingleVisualBlockType;
};

const SingleVisualBlock = ({ block, className }: SingleVisualBlockProps) => {
  return (
    <div
      className={cx(
        className,
        styles.container,
        styles[`visual-${block.config?.visual ?? "left"}`],
      )}
    >
      <Container>
        <div className={styles.main}>
          {block.visual && (
            <div className={styles.visual}>
              <Block block={block.visual} />
            </div>
          )}
          <div className={styles.content}>
            {(block.header || block.subheader) && (
              <div className={styles.headers}>
                {block.header && (
                  <p className={styles.header}>
                    <MarkdownText value={block.header} />
                  </p>
                )}
                {block.subheader && (
                  <h3 className={styles.subheader}>
                    <MarkdownText value={block.subheader} />
                  </h3>
                )}
              </div>
            )}
            {block.content && <Block block={block.content} />}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SingleVisualBlock;
